import React, { useState, useContext, useEffect } from 'react';
import {
  Row,
  Col,
  Input,
  Button,
  Breadcrumb,
  Radio,
  Form,
  Select,
  notification,
} from 'antd';

// Custom imports
import AppContext from '../../context/appContext';
import { BREADCRUMB } from '../../context/types';
import LoadPage from '../../common/loadPage';
import { GET, POST } from '../../common/crud';

const AddAddons = () => {
  const [categoryValue, setCategoryValue] = useState('');
  //  const [architectureValue, setArchitectureValue] = useState('x86_64');
  const [osTypeValue, setOsTypeValue] = useState('');
  const [osBrandValue, setOsBrandValue] = useState('');
  //  const [ramValue, setRamValue] = useState('');
  //  const [diskFormFactorValue, setDiskFormFactorValue] = useState('');
  //  const [diskValue, setDiskValue] = useState('');
  //  const [raidValue, setRaidValue] = useState('');
  const [hddData, setHddData] = useState(null);
  const [ramData, setRamData] = useState(null);
  const [locationList, setLocationList] = useState(null);
  const [location, setLocation] = useState(null);

  const [state, dispatch] = useContext(AppContext);

  const { Option } = Select;

  // Breadcrumb Nav
  const breadNav = (
    <Breadcrumb>
      <Breadcrumb.Item>
        <Button
          type="link"
          className="p-0"
          onClick={() => LoadPage('dashboard', dispatch)}
        >
          Home
        </Button>
      </Breadcrumb.Item>
      <Breadcrumb.Item>Add Addon</Breadcrumb.Item>
    </Breadcrumb>
  );

  // Create Location SUCCESS
  const createAddonSuccess = (values) => {
    console.log('Create Addon Success - ', values);

    let osBody;
    switch (categoryValue) {
      case 'os':
        osBody = {
          location: `${location.split('-')[0]}`,
          ostype: values.ostype,
          brand: values.osbrand,
          title: values.title,
          version: values.version,
          num_unit: values.units,
          price: values.price,
          category: 'os',
          status: true,
        };
        POST('add-ons/os', state.token, osBody).then((res) => {
          console.log('Post Addon res - ', res);
          if (res.success === true) {
            notification.success({
              message: 'Successfully Added!',
              description: 'Data is Successfully Added!',
            });
            LoadPage('allAddons', dispatch);
          } else {
            notification.error({
              message: 'Something Went Wrong!',
              description: `Got Error with status code = ${res.status}!`,
            });
          }
        });
        break;

      case 'ram':
        osBody = {
          location: `${location.split('-')[0]}`,
          price: values.price,
          status: true,
          master_id: values.ram.split('-')[2],
          inventory_id: values.ram.split('-')[1],
        };
        console.log('RAM Post body - ', osBody);
        POST('add-ons/ram', state.token, osBody).then((res) => {
          console.log('Post Addon res - ', res);
          if (res.success === true) {
            notification.success({
              message: 'Successfully Added!',
              description: 'Data is Successfully Added!',
            });
            LoadPage('allAddons', dispatch);
          } else {
            notification.error({
              message: 'Something Went Wrong!',
              description: `Got Error with status code = ${res.status}!`,
            });
          }
        });
        break;

      case 'hdd':
        osBody = {
          location: `${location.split('-')[0]}`,
          price: values.price,
          status: true,
          master_id: values.hdd.split('-')[2],
          inventory_id: values.hdd.split('-')[1],
        };
        console.log('HDD Post body - ', osBody);
        POST('add-ons/hdd', state.token, osBody).then((res) => {
          console.log('Post Addon res - ', res);
          if (res.success === true) {
            notification.success({
              message: 'Successfully Added!',
              description: 'Data is Successfully Added!',
            });
            LoadPage('allAddons', dispatch);
          } else {
            notification.error({
              message: 'Something Went Wrong!',
              description: `Got Error with status code = ${res.status}!`,
            });
          }
        });
        break;

      case 'bandwidth':
        osBody = {
          location: `${location.split('-')[0]}`,
          price: values.price,
          category: 'bandwidth',
          status: true,
        };
        POST('add-ons/bandwidth', state.token, osBody).then((res) => {
          console.log('Post Addon res - ', res);
          if (res.success === true) {
            notification.success({
              message: 'Successfully Added!',
              description: 'Data is Successfully Added!',
            });
            LoadPage('allAddons', dispatch);
          } else {
            notification.error({
              message: 'Something Went Wrong!',
              description: `Got Error with status code = ${res.status}!`,
            });
          }
        });
        break;

      case 'ipaddress':
        osBody = {
          location: `${location.split('-')[0]}`,
          price: values.price,
          category: 'ipaddress',
          status: true,
        };
        POST('add-ons/ipaddress', state.token, osBody).then((res) => {
          console.log('Post Addon res - ', res);
          if (res.success === true) {
            notification.success({
              message: 'Successfully Added!',
              description: 'Data is Successfully Added!',
            });
            LoadPage('allAddons', dispatch);
          } else {
            notification.error({
              message: 'Something Went Wrong!',
              description: `Got Error with status code = ${res.status}!`,
            });
          }
        });
        break;

      case 'raid':
        osBody = {
          location: `${location.split('-')[0]}`,
          raid: values.raid,
          category: 'raid',
          status: true,
          price: 0,
        };
        POST('add-ons/raid', state.token, osBody).then((res) => {
          console.log('Post Addon res - ', res);
          if (res.success === true) {
            notification.success({
              message: 'Successfully Added!',
              description: 'Data is Successfully Added!',
            });
            LoadPage('allAddons', dispatch);
          } else {
            notification.error({
              message: 'Something Went Wrong!',
              description: `Got Error with status code = ${res.status}!`,
            });
          }
        });
        break;

      case 'portspeed':
        osBody = {
          category: 'portspeed',
          location: `${location.split('-')[0]}`,
          port_speed: Number(values.port_speed),
          price: Number(values.price),
          status: true,
        };

        console.log('Port speed body - ', osBody);

        POST('add-ons/portspeed', state.token, osBody).then((res) => {
          console.log('Post Addon res - ', res);
          if (res.success === true) {
            notification.success({
              message: 'Successfully Added!',
              description: 'Data is Successfully Added!',
            });
            LoadPage('allAddons', dispatch);
          } else {
            notification.error({
              message: 'Something Went Wrong!',
              description: `Got Error with status code = ${res.status}!`,
            });
          }
        });
        break;

      default:
        break;
    }
  };

  // Common onChange
  const commonOnChange = () => {};

  // OS Type on change
  const osTypeOnchange = (e) => {
    console.log('OS Type onChange - ', e);
    //  setSelectOSBrand('');
    setOsBrandValue('');
    setOsTypeValue(e.target.value);
  };

  // CategoryValue Select On Change
  const categoryValueSelectOnChange = (value) => {
    console.log('CategoryValue on change - ', value);
    setCategoryValue(value);
  };

  // Brand Select on Change
  const osBrandOnChange = (value) => {
    console.log('Os Brand change - ', osBrandValue);
    setOsBrandValue(value);
  };

  //  OsFileSystem Switch
  let OsFileSystem;
  switch (osBrandValue) {
    case 'Microsoft':
      OsFileSystem = (
        <Col span="6">
          <Form.Item label="ntfs" name="msFileSystem" initialValue={100}>
            <Input
              placeholder="%"
              addonAfter="%"
              disabled
            />
          </Form.Item>
        </Col>
      );
      break;

    case 'RedHat':
      OsFileSystem = (
        <>
          <Col span="4">
            <Form.Item
              label="ext2"
              name="fileSystemLinux1"
              initialValue={10}
            >
              <Input
                type="text"
                placeholder="%"
                addonAfter="%"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span="4">
            <Form.Item
              label="ext3"
              name="fileSystemLinux2"
              initialValue={10}
            >
              <Input
                type="text"
                placeholder="%"
                addonAfter="%"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span="4">
            <Form.Item
              label="ext4"
              name="fileSystemLinux3"
              initialValue={10}
            >
              <Input
                type="text"
                placeholder="%"
                addonAfter="%"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span="4">
            <Form.Item
              label="swap"
              name="fileSystemLinux4"
              initialValue={10}
            >
              <Input
                type="text"
                placeholder="%"
                addonAfter="%"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span="4">
            <Form.Item
              label="xfs"
              name="fileSystemLinux5"
              initialValue={10}
            >
              <Input
                type="text"
                placeholder="%"
                addonAfter="%"
                disabled
              />
            </Form.Item>
          </Col>
          <Col span="4">
            <Form.Item
              label="reiser"
              name="fileSystemLinux6"
            >
              <Input
                type="text"
                placeholder="%"
                addonAfter="%"
                disabled
              />
            </Form.Item>
          </Col>
        </>
      );
      break;

    default:
      break;
  }

  //  Architecture on change
  /* const architectureOnChange = (value) => {
    console.log('Architecture on change - ', value);
    //setArchitectureValue(value);
  }; */

  //  Brand Type on Change
  let OSType;
  switch (osTypeValue) {
    case 'enterprise':
      OSType = (
        <>
          <Col span="12">
            <Form.Item
              label="Brand"
              name="osbrand"
              rules={[
                {
                  required: true,
                  message: 'Select Brand',
                },
              ]}
            >
              <Select
                placeholder="Select Brand"
                onChange={osBrandOnChange}
                style={{ width: '100%' }}
              >
                <Option value="Microsoft">Microsoft</Option>
                <Option value="RedHat">RedHat</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item
              label="Title"
              name="title"
              rules={[
                {
                  required: true,
                  message: 'Enter Title',
                },
              ]}
            >
              <Input placeholder="Enter title..." />
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item
              label="Version"
              name="version"
              rules={[
                {
                  required: true,
                  message: 'Enter Title',
                },
              ]}
            >
              <Input placeholder="Enter title..." />
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item label="Architecture" name="architecture">
              <Select
                placeholder="Select Architecture"
                style={{ width: '100%' }}
                disabled
              >
                <Option value="x86_64">x86_64</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item
              label="# of Unit"
              name="units"
              rules={[
                {
                  required: true,
                  message: 'Select number of of Unit',
                },
              ]}
              initialValue="2"
            >
              <Select
                placeholder="Select Unit"
                onChange={commonOnChange}
                style={{ width: '100%' }}
              >
                <Option value="1">1</Option>
                <Option value="2">2</Option>
                <Option value="3">3</Option>
                <Option value="4">4</Option>
                <Option value="5">5</Option>
                <Option value="6">6</Option>
                <Option value="7">7</Option>
                <Option value="8">8</Option>
                <Option value="9">9</Option>
                <Option value="10">10</Option>
                <Option value="12">12</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item
              label="Price"
              name="price"
              rules={[
                {
                  required: true,
                  message: 'Enter Price',
                },
              ]}
            >
              <Input
                placeholder="Enter price..."
                addonBefore={location ? location.split('-')[2] : ''}
              />
            </Form.Item>
          </Col>
          <Col span="24" style={{ paddingBottom: '8px' }}>
            <strong>File Systems</strong>
          </Col>
          <Col span="24">
            <Row gutter="30">
              {OsFileSystem}
            </Row>
          </Col>
        </>
      );
      break;

    case 'opensource':
      OSType = (
        <>
          <Col span="12">
            <Form.Item
              label="Brand"
              name="osbrand"
              rules={[
                {
                  required: true,
                  message: 'Select Brand',
                },
              ]}
            >
              <Select
                placeholder="Select Brand"
                onChange={osBrandOnChange}
                style={{ width: '100%' }}
              >
                <Option value="Fedora">Fedora</Option>
                <Option value="Ubuntu">Ubuntu</Option>
                <Option value="Linux">Linux</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item
              label="Title"
              name="title"
              rules={[
                {
                  required: true,
                  message: 'Enter Title',
                },
              ]}
            >
              <Input placeholder="Enter title..." />
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item
              label="Version"
              name="version"
              rules={[
                {
                  required: true,
                  message: 'Enter Title',
                },
              ]}
            >
              <Input placeholder="Enter title..." />
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item label="Price" name="price">
              <strong>0</strong>
            </Form.Item>
          </Col>
          <Col span="24" style={{ paddingBottom: '8px' }}>
            <strong>File Systems</strong>
          </Col>
          <Col span="24">
            <Row gutter="30">
              <Col span="4">
                <Form.Item label="ext2" name="fileSystemLinux2">
                  <Input
                    type="text"
                    placeholder="%"
                    addonAfter="%"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span="4">
                <Form.Item label="ext3" name="fileSystemLinux3">
                  <Input
                    type="text"
                    placeholder="%"
                    addonAfter="%"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span="4">
                <Form.Item label="ext4" name="fileSystemLinux4">
                  <Input
                    type="text"
                    placeholder="%"
                    addonAfter="%"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span="4">
                <Form.Item label="swap" name="fileSystemLinux5">
                  <Input
                    type="text"
                    placeholder="%"
                    addonAfter="%"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span="4">
                <Form.Item label="xfs" name="fileSystemLinux6">
                  <Input
                    type="text"
                    placeholder="%"
                    addonAfter="%"
                    disabled
                  />
                </Form.Item>
              </Col>
              <Col span="4">
                <Form.Item label="reiser" name="fileSystemLinux7">
                  <Input
                    type="text"
                    placeholder="%"
                    addonAfter="%"
                    disabled
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </>
      );
      break;

    default:
      break;
  }

  //  Ram on Change
  /* const ramOnChange = (value) => {
    console.log('Ram size on change - ', value);
    setRamValue(value);
  }; */

  //  Ram Technology on change
  /* const ramTechnologyOnChange = (value) => {
    console.log('Ram Technology value - ', value);
    setTechnologyValue(value);
  }; */

  //  Disk Form Factor on change
  /* const diskFormFactorOnChange = (value) => {
    console.log('Disk form factor on change - ', value);
    setDiskFormFactorValue(value);
  }; */

  //  Disk Type on change
  /*  const diskOnChange = (value) => {
    console.log('Disk type on change - ', value);
    setDiskValue(value);
  }; */

  //  RAID on Change
  /* const raidOnChange = (value) => {
    console.log('Raid on change - ', value);
    setRaidValue(value);
  }; */

  //  CategoryValue Form Switch
  let CategoryValueForm;
  switch (categoryValue) {
    case 'os':
      CategoryValueForm = (
        <Row gutter="30">
          <Col span="24">
            <Form.Item
              label="OS Type"
              name="ostype"
              rules={[
                {
                  required: true,
                  message: 'Select OS Type',
                },
              ]}
            >
              <Radio.Group onChange={osTypeOnchange} value={osTypeValue}>
                <Radio value="enterprise">Enterprise</Radio>
                <Radio value="opensource">OpenSource</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          {OSType}
        </Row>
      );
      break;

    case 'ram':
      CategoryValueForm = (

        <Row align="stretch" gutter="30">
          <Col span="12">
            <Form.Item
              label="RAM"
              name="ram"
              rules={[
                {
                  required: true,
                  message: 'Select RAM',
                },
              ]}
            >
              <Select
                placeholder="Select RAM"
                optionFilterProp="children"
              >
                {ramData}
              </Select>
            </Form.Item>
          </Col>

          <Col span="12">
            <Form.Item
              label="Price"
              name="price"
              rules={[
                {
                  required: true,
                  message: 'Enter Price',
                },
              ]}
            >
              <Input
                placeholder="Enter price..."
                  //  addonBefore={<FaRupeeSign color="#666" />}
                addonBefore={location ? location.split('-')[2] : ''}
              />
            </Form.Item>
          </Col>
        </Row>
      );
      break;

    case 'hdd':
      CategoryValueForm = (
        <Row gutter="30">
          <Col span="12">
            <Form.Item
              label="Disk Protocol"
              name="hdd"
              rules={[
                {
                  required: true,
                  message: 'Select Disk Type',
                },
              ]}
            >
              <Select
                placeholder="Select Disk Type"
                optionFilterProp="children"
              >
                {hddData}
              </Select>
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item
              label="Price"
              name="price"
              rules={[
                {
                  required: true,
                  message: 'Enter Price',
                },
              ]}
            >
              <Input
                placeholder="Enter price..."
                addonBefore={location ? location.split('-')[2] : ''}
              />
            </Form.Item>
          </Col>
        </Row>
      );
      break;

    case 'bandwidth':
      CategoryValueForm = (
        <Row gutter="30">
          <Col span="12">
            <Form.Item
              label="Price"
              name="price"
              rules={[
                {
                  required: true,
                  message: 'Enter price',
                },
              ]}
            >
              <Input
                placeholder="Enter Price..."
                addonBefore={location ? location.split('-')[2] : ''}
                addonAfter="/GB"
              />
            </Form.Item>
          </Col>
        </Row>
      );
      break;

    case 'ipaddress':
      CategoryValueForm = (
        <Row gutter="30">
          <Col span="12">
            <Form.Item
              label="Price"
              name="price"
              rules={[
                {
                  required: true,
                  message: 'Enter price',
                },
              ]}
            >
              <Input
                placeholder="Enter Price..."
                addonBefore={location ? location.split('-')[2] : ''}
                addonAfter="/IP"
              />
            </Form.Item>
          </Col>
        </Row>
      );
      break;

    case 'raid':
      CategoryValueForm = (
        <Row gutter="30">
          <Col span="12">
            <Form.Item
              label="RAID"
              name="raid"
              rules={[
                {
                  required: true,
                  message: 'Enter RAID',
                },
              ]}
            >
              <Select
                placeholder="Select Disk Type"
                optionFilterProp="children"
              >
                <Option value="RAID0">RAID0</Option>
                <Option value="RAID1">RAID1</Option>
                <Option value="RAID5">RAID5</Option>
                <Option value="RAID6">RAID6</Option>
                <Option value="RAID10">RAID10</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item label="Price" name="price">
              <strong>0</strong>
            </Form.Item>
          </Col>
        </Row>
      );
      break;

    case 'portspeed':
      CategoryValueForm = (
        <Row gutter="30">
          <Col span="12">
            <Form.Item
              label="Port Speed"
              name="port_speed"
              rules={[
                {
                  required: true,
                  message: 'Enter RAID',
                },
              ]}
            >
              <Select
                placeholder="Select Disk Type"
                optionFilterProp="children"
              >
                <Option value="10">10 Mbps</Option>
                <Option value="100">100 Mbps</Option>
                <Option value="1024">1 Gbps</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span="12">
            <Form.Item label="Price" name="price">
              <Input
                placeholder="Enter price..."
                addonBefore={location ? location.split('-')[2] : ''}
              />
            </Form.Item>
          </Col>
        </Row>
      );
      break;

    default:
      break;
  }

  //  Location On change
  const locationOnChange = (value) => {
    setLocation(value);
  };

  //  Get Locations
  const getLocations = async () => {
    GET('masterdata/locations', state.token).then(async (res) => {
      //  setLoading(false);
      console.log('Get Locations res - ', res);
      if (res.success === true) {
        const locationListArray = (
          await res.data.locations.map((locationRes) => (
            <Option key={locationRes._id} value={`${locationRes.name}-${locationRes.base_currency}-${locationRes.base_currency_symbol}`}>{`${locationRes.name}, ${locationRes.code}`}</Option>
          ))
        );
        console.log('Location list after adding - ', locationListArray);
        setLocationList(locationListArray);
      } else if (res.success === false) {
        notification.error({
          message: 'Something Went Wrong!',
          description: 'Sorry we did not got Locations list from master data!!!',
        });
      }
    }).catch((err) => {
      //  setLoading(false);
      console.log('Get err - ', err);
    });
  };

  //  Get HDD Disks from Inventory
  const getDisks = () => {
    GET('inventory/hdds', state.token).then((res) => {
      if (res.success === true) {
        console.log('Got Inventory HDD - ', res.data);
        const disksListArray = (
          res.data.map((disk) => (
            <Option key={disk._id} value={`${disk.hdd}-${disk._id}-${disk.master_id}`}>{`${disk.hdd}`}</Option>
          ))
        );
        setHddData(disksListArray);
      } else {
        notification.error({
          message: 'HDDs Inventory Data Error!',
          description: 'Something went wrong while getting HDD Disk data from inventory!',
        });
      }
    });
  };

  //  Get RAMs from Inventory
  const getRams = () => {
    GET('inventory/inv_rams', state.token).then((res) => {
      if (res.success === true) {
        console.log('Got Inventory Rams - ', res.data);
        const disksListArray = (
          res.data.map((ram) => (
            <Option key={ram._id} value={`${ram.ram}-${ram._id}-${ram.master_id}`}>{`${ram.ram}`}</Option>
          ))
        );
        setRamData(disksListArray);
      } else {
        notification.error({
          message: 'HDDs Inventory Data Error!',
          description: 'Something went wrong while getting HDD Disk data from inventory!',
        });
      }
    });
  };

  useEffect(() => {
    getDisks();
    getRams();
    getLocations();

    //  Breadcrum Nav
    dispatch({
      type: BREADCRUMB,
      payload: {
        breadcrumb: breadNav,
      },
    });

    return () => {
      dispatch({
        type: BREADCRUMB,
        payload: {
          breadcrumb: null,
        },
      });
    };
  }, []);

  return (
    <>
      <Row>
        <Col span="24" className="full-width page-header">
          <Row align="middle">
            <Col span="14" className="page-title ">
              Add Addon
            </Col>

          </Row>
        </Col>
      </Row>

      <Row gutter="20" className="m-2">
        <Col span="24">
          <Form
            name="basic"
            layout="vertical"
            onFinish={createAddonSuccess}
            autoComplete="off"
            initialValues={{

              msFileSystem: '100',
              fileSystemLinux1: '10',
              fileSystemLinux2: '10',
              fileSystemLinux3: '10',
              fileSystemLinux4: '10',
              fileSystemLinux5: '10',
              fileSystemLinux6: '10',
              fileSystemLinux7: '10',
            }}
          >
            <Row gutter="30" className="flex-direction-column">
              <Col span="12">
                <Form.Item
                  label="Select Location"
                  name="location"
                  rules={[
                    {
                      required: true,
                      message: 'Select Location',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Location"
                    onChange={locationOnChange}
                  >
                    {locationList}
                  </Select>
                </Form.Item>
              </Col>
              <Col span="12">
                <Form.Item
                  label="Select Category"
                  name="category"
                  rules={[
                    {
                      required: true,
                      message: 'Select CategoryValue',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select CategoryValue"
                    onChange={categoryValueSelectOnChange}
                    /* style={{ width: '100%', fontSize: '20px' }}
                    size="large" */
                  >
                    <Option value="os">Operating System</Option>
                    <Option value="ram">RAM</Option>
                    <Option value="hdd">HDD</Option>
                    <Option value="bandwidth">Bandwidth</Option>
                    <Option value="ipaddress">Addtional IPs</Option>
                    <Option value="raid">RAID</Option>
                    <Option value="portspeed">Port Speed</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col span="24">
                {CategoryValueForm}
              </Col>
              <Col span="24" className="my-1 py-2 border-top">
                <Button type="default" size="large" className="me-1 px-2" htmlType="reset">
                  Reset
                </Button>
                <Button
                  type="primary"
                  size="large"
                  className="me-1 btn-success px-4"
                  htmlType="submit"
                >
                  Add
                </Button>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </>
  );
};

export default AddAddons;
